import { cn } from 'domain/core';
import React, { useMemo } from 'react';

import { Card } from 'components';
import { VirtualStation } from 'domain/models/api.models';
import { AppRoutes } from 'domain/routes';
import { AlertList } from 'pages/common/AlertList';
import { DashboardSummary } from 'pages/dashboard/DashboardSummary';
import { useTranslation } from 'react-i18next';
import { useAlertBadge } from 'domain/utils/time.utils';
import { useLatestObservations } from 'domain/hooks/api/observations';
import { dateTimeFormat } from 'domain/utils/date.utils';
import { ALL_VARIABLES } from 'domain/utils/variables';
import { LinkGuard } from 'components/RoleGuard';

export const DashboardCard = ({ item }: { item: VirtualStation }) => {
	const { status } = useAlertBadge(item);

	const { t } = useTranslation(['labels']);

	const [lastData] = useLatestObservations(item.id, ALL_VARIABLES);

	return (
		<Card
			className={cn(
				item.deleted ? 'border-0 opacity-50' : '',
				'min-h-[400px]'
			)}>
			<LinkGuard
				role='ROLE_ADMIN'
				to={AppRoutes.EditVirtualStation.replace(':id', '' + item.id)}>
				<Card.Header>
					<Card.Badge status={status}></Card.Badge>
					<Card.Titles>
						<Card.Title>{item?.name}</Card.Title>
						<Card.Subtitle className='space-between flex'>
							<div>
								{t('labels:lastUpdate')}: {dateTimeFormat(lastData?.timestamp)}
							</div>
						</Card.Subtitle>
					</Card.Titles>
					<Card.Info>
						<Card.InfoItemLabel>
							<div>{t('labels:alerts', { count: item?.alertCount })}</div>
						</Card.InfoItemLabel>
						<Card.InfoItemLabel className='text-xs'>
							{t('labels:1_month')}
						</Card.InfoItemLabel>
					</Card.Info>
				</Card.Header>
			</LinkGuard>
			<Card.Body>
				<React.Suspense fallback={<></>}>
					<DashboardSummary id={item.id} lastData={lastData} />
				</React.Suspense>
				<AlertList list={item?.alerts} />
			</Card.Body>
		</Card>
	);
};
